const Word = ($resource) => {
  'ngInject';
  return $resource(`http://jezor.pl/api/words/:rows/:cols`);
  // return $resource(`http://localhost/jezor/api/words/:rows/:cols`);
};

export default Word;


// WEBPACK FOOTER //
// ./client/app/components/memo/word.factory.js